import styled from 'styled-components';

import { HEADER_HEIGHT } from '../../styles';
import { NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba, spin } from '../../../../utils/style';

interface ButtonProps {
	color: string;
	isOpened: boolean;
	disabled: boolean;
	hasDropdown: boolean;
}

interface OptionButtonProps {
	iconWidth: string;
	iconHeight: string;
	isRotatingIcon?: string;
}

const Wrapper = styled('div')`
	& + & {
		margin-left: 10px;
	}
`;

const Button = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	position: relative;
	display: flex;
	align-items: center;
	height: 30px;
	padding: 5px 20px;
	border: 0;
	border-radius: 15px;
	outline: 0;
	background-color: ${({ color }: ButtonProps) => color};
	font-family: HelveticaNeue, sans-serif;
	font-size: 13px;
	line-height: 19px;
	color: ${NewStyleColor.White};
	cursor: pointer;
	white-space: nowrap;

	${({ disabled }: ButtonProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	${({ hasDropdown }: ButtonProps) => hasDropdown && `
		padding-right: 30px;
	`}

	svg {
		position: absolute;
		top: 50%;
		right: 11px;
		width: 8px;
		height: 8px;
		fill: currentColor;
		transform: translateY(-50%);

		${({ isOpened }: ButtonProps) => isOpened && `
			transform: translateY(-50%) rotate(90deg);
		`}
	}
`;

const Content = styled('div')`
	box-sizing: border-box;
	position: fixed;
	top: calc(${HEADER_HEIGHT}px + 10px);
	right: 12px;
	z-index: 20;
	width: 375px;
	padding: 15px;
	border-radius: 11px;
	background: ${NewStyleColor.Grey900};
	box-shadow: 0 -2px 45px 0 ${hexToRgba(NewStyleColor.Black, 64)};
`;

const ContentHeader = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 15px;
	font-weight: bold;
	font-size: 17px;
	line-height: 20px;
	color: ${NewStyleColor.White};

	> span {
		line-height: 24px;
	}
`;

const OptionButton = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 44px;
	padding: 10px 17px;
	border: 0;
	border-radius: 10px;
	outline: 0;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};
	font-family: HelveticaNeue, sans-serif;
	font-size: 17px;
	line-height: 24px;
	color: ${NewStyleColor.White};
	cursor: pointer;

	&:hover {
		background-color: ${hexToRgba(NewStyleColor.White, 25)};
	}

	& + & {
		margin-top: 15px;
	}

	svg {
		width: ${({ iconWidth }: OptionButtonProps) => iconWidth};
		height: ${({ iconHeight }: OptionButtonProps) => iconHeight};
		fill: currentColor;
		animation: ${spin};
		animation-duration: ${({ isRotatingIcon }: OptionButtonProps) => isRotatingIcon ? '1s' : '0s'};
	}
`;

export {
	Wrapper,
	Button,
	Content,
	ContentHeader,
	OptionButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Header/Dropdown/styles.ts